<title>Autoverkoop Partner - Bod geaccepteerd</title>

<!-- Page Content -->
<div class="container">
    <div class="card border-0 shadow my-5">
        <div class="card-body p-5">
            <img class="img-fluid header-img" src="/assets/images/avp-logo.png">
            <hr>

            <h1 class="font-weight-light">Gefeliciteerd, je hebt jouw auto verkocht!</h1>

            <div class="alert alert-success" role="alert">
                Een e-mail met aanvullende informatie is naar je verzonden.
            </div>

            <p class="lead">
                We hebben nog wat extra gegevens van je nodig. Vul deze meteen even in of doe dit op een later moment.
            </p>

            <button (click)="nextStep()" type="button" class="btn btn-primary">Extra gegevens aanleveren</button>

            <div style="height: 700px"></div>
        </div>
    </div>
</div>
